export default "__VITE_ASSET__C33uxYcb__"